export default function CTAAppel() {
  return (
    <section className="bg-brand-blue py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-white text-xl md:text-2xl font-bold mb-3">
          Besoin d'un devis pour la pose d'un volet roulant ?
        </h2>
        <p className="text-white/80 text-base md:text-lg leading-relaxed mb-6">
          Nos techniciens se déplacent gratuitement à Strasbourg et dans le Bas-Rhin pour une visite et un devis sans engagement.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
          <a
            href="tel:0374473240"
            className="inline-flex items-center justify-center gap-2 bg-brand-cyan text-white px-7 py-3.5 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            <span className="btn-icon-wrap"><i className="ri-phone-line text-lg"></i></span>
            Appeler le 03 74 47 32 40
          </a>
          <a
            href="#devis"
            className="inline-flex items-center justify-center gap-2 bg-white text-brand-blue px-7 py-3.5 rounded-full font-semibold text-base hover:bg-brand-light transition-all duration-200 btn-hover-effect whitespace-nowrap"
          >
            Devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
}